import {useEffect, useRef, useState} from "react";
// import profilePhoto from "../../assets/profilephoto.jpg";
import profilePhoto from "../../assets/my-character.jpg";
import {BTN_KEY} from "../../util/util";

import icnImg from "../../assets/icn.jpg";
import ssyyImg from "../../assets/ssyy.png";

const Others2 = ({changeBtnKey, setCanAllShow = () => {}, allMode = false}) => {
    const stickerItemList = [
        {
            imagePath: profilePhoto,
        },
    ]

    const [localShowAll, setLocalShowAll] = useState(false);
    const othersInfo = {
        initTitle : `안녕하세요 개발자 이준복입니다.`,
    }

    const commonProfileTitle = '프로필(Profile)';
    const commonStudyTitle = '교육(Education)';
    const certificationTitle = '자격증(Certifications)';
    const commonSkillsTitle= '기술(Skills)';


    const studyList = [
        {
            img: ssyyImg,
            content:'"실무 프로젝트 기반 빅데이터 서비스 솔루션 개발자 양성과정 4기" Java 기반 풀스택 프로그래밍 과정',
            period:'2023.01 ~ 2023.08',
            server: '쌍용강북교육센터',
        },
        {
            img: icnImg,
            content:'Front-End 입문을 위한 HTML5 웹프로그래밍',
            period:'2022.12 ~ 2023.01',
            server: '인천대학교',
        }
    ]

    const certificationList = [
        {
            content:'토익스피킹 IH(150)',
            period:'2025.12',
        },
        {
            content:'정보처리기사',
            period:'2023.11',
        },
        {
            content:'파이썬 마스터 3급',
            period:'2023.09',
        },
        {
            content:'SQLD (SQL 개발자)',
            period:'2023.07',
        },
        {
            content:'산업안전산업기사',
            period:'2022.09',
        },
        {
            content:'워드프로세서',
            period:'2022.02',
        },
        {
            content:'운전면허 (1종 보통)',
            period:'2018.04',
        }
    ]

    const skillList = [
        {
            type: 'fe',
            name: 'React',
        },
        {
            type: 'fe',
            name: 'JS',
        },
        {
            type: 'be',
            name: 'JAVA',
        },
        {
            type: 'be',
            name: 'Spring',
        },
        {
            type: 'be',
            name: 'MyBatis',
        },
        {
            type: 'be',
            name: 'JPA',
        },
        {
            type: 'db',
            name: 'Oracle',
        },
        {
            type: 'db',
            name: 'MySQL',
        },
        {
            type: 'db',
            name: 'MariaDB'
        },
        {
            type: 'os',
            name: 'Windows',
        },
        {
            type: 'os',
            name: 'Linux',
        },
        {
            type: 'solution',
            name: 'AEM',
        },
        {
            type: 'solution',
            name: 'AWS',
        },
        {
            type: 'svn',
            name: 'Git',
        },
        {
            type: 'svn',
            name: 'Nginx'
        },
    ]

    const groupedSkills = skillList.reduce((acc, item) => {
        if (!acc[item.type]) acc[item.type] = [];
        acc[item.type].push(item);
        return acc;
    }, {});

    const skillCategory = {
        fe : '프론트엔드',
        be : '백엔드',
        db : 'DB',
        os : '운영환경',
        solution: '솔루션',
        svn: '기타',
    }

    const skillCategoryBgClassName = {
        fe : 'bg-light shadow-sm',
        be : 'bg-light shadow-sm',
        db : 'bg-light shadow-sm',
        os : 'bg-light shadow-sm',
        solution: 'bg-light shadow-sm',
        svn: 'bg-light shadow-sm',
    }
    const skillCategoryTitleClassName = {
        fe : 'text-success',
        be : 'text-primary',
        db : 'text-info',
        os : '',
        solution: 'text-warning',
        svn: '',
    }



    useEffect(() => {
        const initRender = setTimeout(() => {
            setLocalShowAll(true);
            setCanAllShow(true);
        }, 2000);

        return () => {
            clearTimeout(initRender);
        }
    }, []);


    const skillClassMapData = {
        fe: 'badge d-flex align-items-center p-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill',
        be: 'badge d-flex align-items-center p-1 pe-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill',
        db: 'badge d-flex align-items-center p-1 pe-2 text-info-emphasis bg-info-subtle border border-info-subtle rounded-pill',
        os: 'badge d-flex align-items-center p-1 pe-2 text-dark-emphasis bg-light-subtle border border-dark-subtle rounded-pill',
        solution: 'badge d-flex align-items-center p-1 pe-2 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill',
        svn: 'badge d-flex align-items-center p-1 pe-2 text-bg-dark border rounded-pill'
    }

    const activeTarget = 'choice-summary-3';
    const focusRef = useRef();
    useEffect(() => {
        // if (allMode) return;
        if (localShowAll) {
            document.querySelector(`#${activeTarget}`)?.classList?.add('border-primary');
            focusRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    },[localShowAll]);

    return (
        <>
            <div className='container'>
                <hr className='featurette-divider'/>
                {/*{!allMode && (*/}
                <div className='right-align'>
                    <h4>
                        <div>
                            <div className="fold-btn mt-2 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                     fill="currentColor"
                                     className="bi bi-x-circle custom-fold-top" viewBox="0 0 16 16"
                                     onClick={() => {
                                         changeBtnKey(BTN_KEY.DEFAULT);
                                     }}>
                                    <path
                                        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                    <path
                                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"></path>
                                </svg>
                            </div>
                        </div>
                    </h4>
                </div>
                <div className="code-bg bg-gradient d-flex align-items-center justify-content-center text-center"
                     style={{height: "200px"}}>
                    <h4 className="code-index typing  mb-0">
                        {othersInfo.initTitle}
                    </h4>
                </div>
                {localShowAll && (
                    <div className='fade-item' ref={focusRef}>
                        <div className="container px-0 py-5">
                            <h2 className="pb-2 border-bottom">
                                {commonProfileTitle}
                            </h2>
                            <div className="row row-cols-1 row-cols-md-2 align-items-md-center g-5 py-5">
                                <div className="col d-flex flex-column align-items-start gap-2">
                                    <div className="col-12 col-sm-12 text-center p-4">
                                        <div className="position-relative d-inline-block">
                                            <img
                                                src={stickerItemList?.[0]?.imagePath}
                                                className="img-fluid rounded-5 profile-img-bs"
                                                alt="profile"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="row row-cols-1 row-cols-sm-2 g-4">
                                        <div className="col d-flex flex-column gap-2">
                                            <div
                                                className="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3">
                                                {/*<svg className="bi" width="1em" height="1em" aria-hidden="true">*/}
                                                {/*    <use xlink:href="#collection"></use>*/}
                                                {/*</svg>*/}
                                            </div>
                                            <h4 className="fw-semibold mb-0 text-body-emphasis">
                                                이름
                                            </h4>
                                            <p
                                                className="text-body-secondary">
                                                이준복
                                            </p>
                                        </div>
                                        <div className="col d-flex flex-column gap-2">
                                            <div
                                                className="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3">
                                                {/*<svg className="bi" width="1em" height="1em" aria-hidden="true">*/}
                                                {/*    <use xlink:href="#gear-fill"></use>*/}
                                                {/*</svg>*/}
                                            </div>
                                            <h4 className="fw-semibold mb-0 text-body-emphasis">
                                                생년월일
                                            </h4>
                                            <p className="text-body-secondary">
                                                96.07.16
                                            </p>
                                        </div>
                                        <div className="col d-flex flex-column gap-2">
                                            <div
                                                className="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3">
                                                {/*<svg className="bi" width="1em" height="1em" aria-hidden="true">*/}
                                                {/*    <use xlink:href="#speedometer"></use>*/}
                                                {/*</svg>*/}
                                            </div>
                                            <h4 className="fw-semibold mb-0 text-body-emphasis">
                                                학력
                                            </h4>
                                            <p
                                                className="text-body-secondary">
                                                인천대학교 물리학과 졸업
                                            </p>
                                        </div>
                                        <div className="col d-flex flex-column gap-2">
                                            <div
                                                className="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3">
                                                {/*<svg className="bi" width="1em" height="1em" aria-hidden="true">*/}
                                                {/*    <use xlink:href="#table"></use>*/}
                                                {/*</svg>*/}
                                            </div>
                                            <h4 className="fw-semibold mb-0 text-body-emphasis">
                                                이메일
                                            </h4>
                                            <p
                                                className="text-body-secondary">
                                                leejb0011@naver.com
                                            </p>
                                        </div>
                                        <div className="col d-flex flex-column gap-2">
                                            <div
                                                className="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3">
                                                {/*<svg className="bi" width="1em" height="1em" aria-hidden="true">*/}
                                                {/*    <use xlink:href="#table"></use>*/}
                                                {/*</svg>*/}
                                            </div>
                                            <h4 className="fw-semibold mb-0 text-body-emphasis">
                                                블로그
                                            </h4>
                                            <p
                                                className="text-body-secondary">
                                                <a className='no-line-href' target='_blank' href='https://letsdodev.tistory.com' rel="noreferrer">
                                                    letsdodev.tistory.com
                                                </a>
                                            </p>
                                        </div>
                                        <div className="col d-flex flex-column gap-2">
                                            <div
                                                className="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3">
                                                {/*<svg className="bi" width="1em" height="1em" aria-hidden="true">*/}
                                                {/*    <use xlink:href="#table"></use>*/}
                                                {/*</svg>*/}
                                            </div>
                                            <h4 className="fw-semibold mb-0 text-body-emphasis">
                                                깃허브
                                            </h4>
                                            <p
                                                className="text-body-secondary">
                                                <a className='no-line-href' target='_blank' href='https://github.com/ljbok/' rel="noreferrer">
                                                    https://github.com/ljbok/
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <>
                            {/* 교육 */}
                            <h2 className="pb-2 border-bottom">{commonStudyTitle}</h2>
                            {/*<div className="custom-edu-card row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4 py-5">*/}
                            <div className="custom-edu-card row row-cols-1 row-cols-sm-2 row-cols-md-2 g-4 py-5">
                                {studyList.map((item, index) => (
                                    <div className="col" key={index + 1}>
                                        <div className="card edu-card h-100 border-0 rounded-4 overflow-hidden">
                                            <div className="edu-img-wrapper">
                                                <img
                                                    src={item.img}
                                                    alt="img"
                                                    className="card-img-top"
                                                />
                                            </div>
                                            <div className="card-body text-center">
                                              <span className="badge bg-info-subtle text-primary fw-semibold mb-2">
                                                {item.server}
                                              </span>
                                                <span className="badge bg-success-subtle text-success fw-semibold mb-2">
                                                    {item.period}
                                                </span>
                                                <h5 className="fw-bold text-dark mb-2">{item.content}</h5>
                                                {/*<p className="text-muted mb-0">{item.period}</p>*/}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*<hr/>*/}
                            {/*자격증*/}
                            <h2 className="mb-3 pb-2 border-bottom">{certificationTitle}</h2>
                            <div className="row justify-content-center">
                                {certificationList.map((item, index) => (
                                    <div className="col-12 col-md-6 col-lg-4 mb-4" key={`cert-${index + 1}`}>
                                        <div className="card cert-card border-0 rounded-2 p-4 h-100 text-center">
                                            {/* 순서 번호 */}
                                            {/*<div className="cert-number mb-3">{index + 1}</div>*/}
                                            {/* 내용 */}
                                            <h6 className="fw-semibold text-dark mb-2">{item.content}</h6>
                                            <p className="text-muted mb-0">{item.period}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*<hr/>*/}
                            {/* 기술 */}
                            <h2 className="mt-5 mb-3 pb-2 border-bottom">{commonSkillsTitle}</h2>
                            <div className="custom-skill-icon-group">
                                {Object.entries(groupedSkills).map(([type, items], groupIndex) => (
                                    <div key={type} className={`skill-block mb-1 ${skillCategoryBgClassName?.[type]}`}>
                                        <div className="row align-items-center">
                                            {/* 설명 영역 */}
                                            <div className="col-12 col-md-3 text-md-end text-center mb-md-0">
                                                <h6 className={`fw-bolder skill-title ${skillCategoryTitleClassName?.[type]}`}>{skillCategory[type]}</h6>
                                            </div>
                                            <div
                                                className="col-12 col-md-9 d-flex flex-wrap gap-2 justify-content-center">
                                                {items.map((item, index) => (
                                                    <span
                                                        key={`skill-${type}-${index}`}
                                                        className={`custom-skill-icon d-flex align-items-center justify-content-center ${
                                                            skillClassMapData?.[item.type] || ''
                                                        }`}
                                                    >
                                            {item.name}
                                          </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    </div>
                )}
            </div>
        </>
    )
}

export default Others2